/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import { Box } from "@mui/material";
import React, { ReactNode, useContext, createContext } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface RecaptchaConext {
  getRecaptchaToken: () => Promise<string>;
}

const recaptchaContext = createContext<RecaptchaConext>({
  getRecaptchaToken: () => Promise.resolve(""),
});

export function RecaptchaProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const recaptchaRef = React.useRef(null);
  const contextValue: RecaptchaConext = {
    getRecaptchaToken: async () => {
      const current = recaptchaRef.current as any;
      if (current) {
        if (current.getValue()) {
          await current.reset();
        }
        CreateAnalyticEvent({
          event: {
            adIds: ["NONE"],
            eventType: "RECAPTCHA#START",
          },
        });
        const token = await current.executeAsync();
        CreateAnalyticEvent({
          event: {
            adIds: ["NONE"],
            eventType: "RECAPTCHA#COMPLETE",
          },
        });
        return token;
      } else {
        throw new Error("Recaptcha ref is not initialized");
      }
    },
  };
  return (
    <recaptchaContext.Provider value={contextValue}>
      {children}
      <Box
        sx={{
          ".grecaptcha-badge": { visibility: "hidden" },
        }}
      >
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={"6LdhsugqAAAAAA_Ar0hmhwvnQ_LhJyqrDu66_Dsv"} // AJB: config
        />
      </Box>
    </recaptchaContext.Provider>
  );
}

export function useRecaptcha() {
  const context = useContext(recaptchaContext);
  if (!context) {
    throw new Error("useRecaptcha must be used within a RecaptchaProvider");
  }
  return context;
}
